/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponsServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var CouponsServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Coupons: function () {
            return function (headers) {
                var service = {
                    calculateCart: function (v1CalculateRequest) {
                        return httpClient.invoke('POST', '/api/v1/coupons/codes/{code}/calculate-cart', v1CalculateRequest, headers);
                    },
                    create: function (v1CreateCouponRequest) { return httpClient.invoke('POST', '/api/v1/coupons', v1CreateCouponRequest, headers); },
                    delete: function (v1DeleteCouponRequest) {
                        return httpClient.invoke('DELETE', '/api/v1/coupons/{id}', v1DeleteCouponRequest, headers);
                    },
                    get: function (v1GetCouponRequest) { return httpClient.invoke('GET', '/api/v1/coupons/{id}', v1GetCouponRequest, headers); },
                    hasCoupons: function (v1HasCouponsRequest) {
                        return httpClient.invoke('GET', '/api/v1/coupons/has-coupons', v1HasCouponsRequest, headers);
                    },
                    increaseUsage: function (v1IncreaseUsageRequest) {
                        return httpClient.invoke('POST', '/api/v1/coupons/{id}/increase-usage', v1IncreaseUsageRequest, headers);
                    },
                    list: function (listCouponsRequest) { return httpClient.invoke('GET', '/api/v1/coupons', listCouponsRequest, headers); },
                    update: function (v1UpdateCouponRequest) {
                        return httpClient.invoke('PATCH', '/api/v1/coupons/{id}', v1UpdateCouponRequest, headers);
                    },
                };
                service.calculateCart.__http_method = 'POST';
                service.calculateCart.__http_url = '/api/v1/coupons/codes/{code}/calculate-cart';
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/v1/coupons';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/api/v1/coupons/{id}';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/v1/coupons/{id}';
                service.hasCoupons.__http_method = 'GET';
                service.hasCoupons.__http_url = '/api/v1/coupons/has-coupons';
                service.increaseUsage.__http_method = 'POST';
                service.increaseUsage.__http_url = '/api/v1/coupons/{id}/increase-usage';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/v1/coupons';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = '/api/v1/coupons/{id}';
                return service;
            };
        },
        CouponsManagerUI: function () {
            return function (headers) {
                var service = {
                    getAllScopeConfigs: function (allScopeConfigsRequest) {
                        return httpClient.invoke('GET', '/api/v2/coupons-scope-configs', allScopeConfigsRequest, headers);
                    },
                    getItems: function (getItemsRequest) { return httpClient.invoke('GET', '/api/v2/items', getItemsRequest, headers); },
                    getShoutoutAdditionalItems: function (getShoutoutAdditionalItemsRequest) {
                        return httpClient.invoke('GET', '/api/v2/shoutout-addtional-items/{couponId}', getShoutoutAdditionalItemsRequest, headers);
                    },
                };
                service.getAllScopeConfigs.__http_method = 'GET';
                service.getAllScopeConfigs.__http_url = '/api/v2/coupons-scope-configs';
                service.getItems.__http_method = 'GET';
                service.getItems.__http_url = '/api/v2/items';
                service.getShoutoutAdditionalItems.__http_method = 'GET';
                service.getShoutoutAdditionalItems.__http_url = '/api/v2/shoutout-addtional-items/{couponId}';
                return service;
            };
        },
        CouponsV2: function () {
            return function (headers) {
                var service = {
                    bulkCreateCoupons: function (bulkCreateCouponsRequest) {
                        return httpClient.invoke('POST', '/v2/bulk/coupons/create', bulkCreateCouponsRequest, headers);
                    },
                    bulkDeleteCoupons: function (bulkDeleteCouponsRequest) {
                        return httpClient.invoke('POST', '/v2/bulk/coupons/delete', bulkDeleteCouponsRequest, headers);
                    },
                    calculateCart: function (v2CalculateRequest) {
                        return httpClient.invoke('POST', '/api/v2/coupons/codes/{code}/calculate-cart', v2CalculateRequest, headers);
                    },
                    create: function (v2CreateCouponRequest) { return httpClient.invoke('POST', '/v2/coupons', v2CreateCouponRequest, headers); },
                    delete: function (v2DeleteCouponRequest) {
                        return httpClient.invoke('DELETE', '/v2/coupons/{id}', v2DeleteCouponRequest, headers);
                    },
                    get: function (v2GetCouponRequest) { return httpClient.invoke('GET', '/v2/coupons/{id}', v2GetCouponRequest, headers); },
                    hasCoupons: function (v2HasCouponsRequest) {
                        return httpClient.invoke('GET', '/api/v2/coupons/has-coupons', v2HasCouponsRequest, headers);
                    },
                    increaseUsage: function (v2IncreaseUsageRequest) {
                        return httpClient.invoke('POST', '/api/v2/coupons/{id}/increase-usage', v2IncreaseUsageRequest, headers);
                    },
                    query: function (queryCouponsRequest) { return httpClient.invoke('POST', '/v2/coupons/query', queryCouponsRequest, headers); },
                    update: function (v2UpdateCouponRequest) { return httpClient.invoke('PATCH', '/v2/coupons/{id}', v2UpdateCouponRequest, headers); },
                };
                service.bulkCreateCoupons.__http_method = 'POST';
                service.bulkCreateCoupons.__http_url = '/v2/bulk/coupons/create';
                service.bulkDeleteCoupons.__http_method = 'POST';
                service.bulkDeleteCoupons.__http_url = '/v2/bulk/coupons/delete';
                service.calculateCart.__http_method = 'POST';
                service.calculateCart.__http_url = '/api/v2/coupons/codes/{code}/calculate-cart';
                service.create.__http_method = 'POST';
                service.create.__http_url = '/v2/coupons';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/v2/coupons/{id}';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/v2/coupons/{id}';
                service.hasCoupons.__http_method = 'GET';
                service.hasCoupons.__http_url = '/api/v2/coupons/has-coupons';
                service.increaseUsage.__http_method = 'POST';
                service.increaseUsage.__http_url = '/api/v2/coupons/{id}/increase-usage';
                service.query.__http_method = 'POST';
                service.query.__http_url = '/v2/coupons/query';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = '/v2/coupons/{id}';
                return service;
            };
        },
    };
};
exports.CouponsServer = CouponsServer;
exports.CouponsServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map